import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Tabs } from "../../themes/Default/components/Tabs";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { useTranslation } from "react-i18next";
import { studentGuardianManagement } from "../../hooks/api/StudentGuardianManagement";
import { List } from "../../themes/Default/components/List";
import { Header as ListHeader } from "../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../themes/Default/components/List/components/Body";
import { TableHead } from "../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Button, ButtonBack } from "../../themes/Default/components/TopNavigation/components/Button";

const GuardianStudents = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const { guardianId } = useParams();
    const [students, setStudents] = useState([]);

    const { useViewGuardianMutation } = studentGuardianManagement;
    const [viewGuardian] = useViewGuardianMutation();

    const tabs = [
        { title: t("details"), onClick: () => gotoDetailsTab(guardianId) },
        { title: t("guardians.students"), isActive: true },
    ];

    const gotoDetailsTab = (guardianId) => {
        navigate("/guardians/edit/" + guardianId);
    };

    const gotoStudent = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    useEffect(() => {
        viewGuardian({guardianId}).then((result) => {
            setStudents(result?.data?.students);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/guardians" />
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("guardians.title")} icon="fa-user-graduate" />
                    <Link title={t("details")} />
                    <Link title={t("guardians.students")} isActive={true} />
                </Breadcrumps>
                <List>
                    <ListHeader>
                    </ListHeader>
                    <ListBody>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell></TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("students.firstName")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("students.lastName")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("students.grade")}</span>
                                </TableHeadCell>
                                <TableHeadCell>
                                    <span>{t("students.dateOfBirth")}</span>
                                </TableHeadCell>
                                <TableHeadCell></TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {students?.length > 0 &&
                            students?.map((student, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableDataCell><Button icon="fa-regular fa-eye" onClick={() => gotoStudent(student.id)}/></TableDataCell>
                                        <TableDataCell>{student.firstName}</TableDataCell>
                                        <TableDataCell>{student.lastName}</TableDataCell>
                                        <TableDataCell>{student.grade}</TableDataCell>
                                        <TableDataCell>{student.dateOfBirth}</TableDataCell>
                                        <TableDataCell></TableDataCell>
                                    </TableRow>
                                )
                        })}
                        </TableBody>
                    </ListBody>
                </List>
            </Main>
        </DefaultLayout>
    );
};

export default GuardianStudents;
